export function streamFromAsyncBlob(blobGetter) {
    const { writable, readable } = new TransformStream();
    async function propagateErrorToStream(error) {
        await Promise.allSettled([writable.abort(error), readable.cancel(error)]);
    }
    async function pipeFetchToStream() {
        const blob = await blobGetter();
        await blob.stream().pipeTo(writable);
    }
    void pipeFetchToStream().catch(propagateErrorToStream);
    return readable;
}
//# sourceMappingURL=stream_from_async_blob.js.map